import {
  Observer,
  observer,
  useLocalObservable,
} from 'mobx-react-lite';
import React from 'react';

import { IListViewProps, ListView } from '../views/ListView';
import { Separator } from '../common/Separator';
import { PostItem, IPostItemProps } from './PostItem';
import { PostRefModelType } from '@models/Posts/PostModel';

export interface IPostListStore {
  id: number | null;
  setId(id: number): void;
}

export interface IPostListProps
  extends Omit<IListViewProps<PostRefModelType>, 'renderItem'> {
  onPress: IPostItemProps['onPress'];
}

export const PostList = observer(
  ({ data, onPress, ...props }: IPostListProps) => {
    const postListStore = useLocalObservable<IPostListStore>(() => ({
      id: null,

      setId(value: number) {
        this.id = value;
      },
    }));

    return (
      <ListView<PostRefModelType>
        keyExtractor={(i) => i.id.toString()}
        data={data}
        renderItem={({ item }) => (
          <Observer>
            {() => (
              <PostItem
                item={item.current}
                onPress={onPress}
                postListStore={postListStore}
              />
            )}
          </Observer>
        )}
        ItemSeparatorComponent={() => (
          <Separator size={['$9', '$10']} />
        )}
        {...props}
      />
    );
  },
);
